export const CashPayment = () => {
  return (
    <section>
      <h5>Cash Payment</h5>
      <p className="small-text-size" style={{ maxWidth: "450px" }}>
        Kindly confirm you have received the total amount in the payment summary
      </p>
    </section>
  );
};
